// APP版本管理
import http from "@/jslibs/axios/http";

// 列表
export const page = (data) => http.post("/web/deviceManager/getDeviceAccessoryList", data);

// 新增
export const add = (data) => http.post("/web/contentManager/addAppVersion", data);

// 删除
export const del = (data) => http.post("/web/contentManager/deleteAppVersion", data);

// 详情
export const detail = (data) => http.post("/web/deviceManager/getDeviceAccessoryDetail", data);

// 编辑 
export const edit = (data) => http.post("/web/contentManager/updateAppVersion", data);

// 设备基础信息列表 
export const getDeviceBaseInfoList = (data) => http.post("/web/deviceManager/getDeviceBaseInfoList", data);

// 编辑设备基础信息 
export const editDeviceBaseInfo = (data) => http.post("/web/deviceManager/editDeviceBaseInfo", data);

// 设备数据读取记录列表 
export const getDeviceDataReadRecordList = (data) => http.post("/web/deviceManager/getDeviceDataReadRecordList", data);

// 终端类型下拉选 
export const getProductTypeList = (data) => http.post("/web/deviceManager/getProductTypeList", data);

// 获取设备类型列表
export const getDeviceTypeList = (data) => http.post("/web/deviceManager/getDeviceTypeList", data);

// 导入设备基础信息
export const importDeviceBaseInfo = (file) => {
    const params = new FormData();
    params.append('file', file);
    const config = {
        "Content-Type": "multipart/form-data;charset=utf-8",
        formData: true,
    };
    return http.post("/web/deviceManager/importDeviceBaseInfo", params, config);
}